<template>
  <suspense>
    <template #default>
      <layout-support>
        <template #default>
          <slot />
        </template>
      </layout-support>
    </template>
    <template #fallback>
      <loading-screen />
    </template>
  </suspense>
</template>

<script lang="ts" setup>
import { defineAsyncComponent } from 'vue'

const LoadingScreen = defineAsyncComponent(() => import('@/shared/components/loading-screen/ui/loading-screen.vue'))
const LayoutSupport = defineAsyncComponent(() => import('@/widgets/layout').then(({ LayoutSupport }) => LayoutSupport))

</script>
